module.exports = __webpack_public_path__ + "static/media/bitcoin_star.defa76ec.png";